import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { FullWidthContainer } from 'atoms/layout/FullWidthContainer';
import { Tab, TabBar } from 'atoms/navigation/TabBar';
import {
  glossary,
  navLabels,
  playerDetails,
  scoutingCenter,
} from 'lib/glossary';

export type Props = {
  tabs: Partial<Record<PlayerPageTabs, { to: string; onClick?: () => void }>>;
};

export enum PlayerPageTabs {
  PERFORMANCE = 'PERFORMANCE',
  FIXTURES = 'FIXTURES',
  TRANSACTIONS = 'TRANSACTIONS',
  WATCHLISTS = 'WATCHLISTS',
  CARDS = 'CARDS',
  HISTORY = 'HISTORY',
}

const tabsTitle: { [key in PlayerPageTabs]?: MessageDescriptor } = {
  [PlayerPageTabs.PERFORMANCE]: playerDetails.performance,
  [PlayerPageTabs.FIXTURES]: navLabels.fixtures,
  [PlayerPageTabs.TRANSACTIONS]: glossary.transactions,
  [PlayerPageTabs.HISTORY]: navLabels.history,
  [PlayerPageTabs.WATCHLISTS]: scoutingCenter.watchlists,
};

export const Tabs = ({ tabs }: Props) => {
  const tabsToDisplay = Object.keys(tabs) as PlayerPageTabs[];
  return (
    <FullWidthContainer.NoPadding>
      <TabBar variant="flat" fullWidth>
        {tabsToDisplay.map(tab => (
          <Tab
            key={tab}
            to={tabs[tab]?.to}
            onClick={tabs[tab]?.onClick}
            preventScrollReset
          >
            <FormattedMessage {...tabsTitle[tab]} />
          </Tab>
        ))}
      </TabBar>
    </FullWidthContainer.NoPadding>
  );
};
